<template>
  <div class="login">
    <van-dropdown-menu style="width:100%; background: #000 !important;">
      <van-dropdown-item
        v-model="value1"
        :options="option1"
        @change="onChange"
      />
    </van-dropdown-menu>
    <div class=" bodybox ninew">
      <div class="logo ">
        <van-image
          class="bg"
          width="100%"
          fit="contain"
          src="static/img/bg.png"
        >
        </van-image>
        <van-image
          class="log"
          width="40%"
          fit="contain"
          src="static/img/log.png"
        >
        </van-image>
      </div>
      <div class="inputBox">
        <div class="box">
          <van-field
            v-model="username"
            clearable
            :placeholder="$t('Login.account')"
          >
            <van-icon
              name="static/img/login_phone.png"
              slot="left-icon"
              size="22px"
            />
          </van-field>
          <van-field
            v-model="password"
            type="password"
            :placeholder="$t('Login.password')"
          >
            <van-icon
              name="static/img/login_Password.png"
              slot="left-icon"
              size="22px"
            />
          </van-field>
          <van-row style="padding: 10px 0;">
            <van-col
              span="12"
              @click.native="$router.push('/ForgetPassword')"
              >{{ $t("Login.forgetPassword") }}</van-col
            >
            <van-col
              span="12"
              style="text-align: right;"
              @click.native="$router.push('/Register')"
              >{{ $t("Login.register") }}</van-col
            >
          </van-row>
        </div>
        <van-button class="loginBtn" type="default" @click="login()">{{
          $t("Login.login")
        }}</van-button>
      </div>
      <div class="intro">
        <div class="introItem">
          <van-image
            width="40px"
            height="40px"
            class="next"
            fit="contain"
            src="static/img/01@2x.png"
          >
          </van-image>
          <van-image
            width="80%"
            class="proImg"
            fit="contain"
            src="static/img/img2.png"
          >
          </van-image>
          <div class="title van-multi-ellipsis--l2">
            {{ $t("Login.title1") }}
          </div>
          <p class="text">{{ $t("Login.intro1") }}</p>
        </div>
        <div class="introItem">
          <van-image
            width="40px"
            height="40px"
            class="next"
            fit="contain"
            src="static/img/02@2x.png"
          >
          </van-image>
          <van-image
            width="80%"
            class="proImg"
            fit="contain"
            src="static/img/img2.png"
          >
          </van-image>
          <div class="title van-multi-ellipsis--l2">
            {{ $t("Login.title2") }}
          </div>
          <p class="text">{{ $t("Login.intro2") }}</p>
        </div>
        <div class="introItem">
          <van-image
            width="40px"
            height="40px"
            class="next"
            fit="contain"
            src="static/img/03@2x.png"
          >
          </van-image>
          <van-image
            width="80%"
            class="proImg"
            fit="contain"
            src="static/img/img1.png"
          >
          </van-image>
          <div class="title van-multi-ellipsis--l2">
            {{ $t("Login.title3") }}
          </div>
          <p class="text">{{ $t("Login.intro3") }}</p>
        </div>
      </div>
      <div class="last">
        <van-image width="100%" fit="contain" src="static/img/bg2.png">
        </van-image>
        <div class="title van-multi-ellipsis--l2">{{ $t("Login.title4") }}</div>
        <p class="text">{{ $t("Login.intro4") }}</p>
      </div>
      <van-button
        class="callme"
        small
        round
        type="default"
        @click="$router.push('/ContactUs')"
        >{{ $t("Login.contactUs") }}</van-button
      >
      <div class="copyright">copyright Egg Carton Studios Ltd.</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      value1: "",
      option1: [
        { text: "简体中文", value: "zh" },
        { text: "繁體中文", value: "hk" },
        { text: "English", value: "en" }
      ]
    };
  },
  mounted() {
    this.$i18n.locale = localStorage.getItem("langs") || "en";
    this.value1 = this.$i18n.locale;
    this.changeLocale = localStorage.getItem("bgLangsVal") || "en";
    console.log(this.changeLocale);
    this.changeLang();
  },
  methods: {
    login() {
      if (this.username && this.password) {
        this.$axios({
          method: "post",
          url: this.$build + "/api/user/login",
          data: {
            account: this.username,
            password: this.password
          }
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              sessionStorage.setItem("token", res.data.success.token);
              this.$toast({
                type: "success",
                message: res.data.message
              });
              const vm = this;
              setTimeout(function() {
                // vm.$router.push('/Center');
                vm.$router.replace("/Center");
              }, 1000);
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("center.message")
            });
          });
      } else {
        this.$toast(this.$t("Login.toast"));
      }
    },
    //多语言选择
    onChange(value) {
      console.log(value);
      if (value == "zh") {
        this.$i18n.locale = "zh";
        localStorage.setItem("langs", "zh");
        localStorage.setItem("langsVal", "简体中文");
        this.changeLocale = "zh_cn";
      } else if (value == "hk") {
        this.$i18n.locale = "hk";
        localStorage.setItem("langs", "hk");
        localStorage.setItem("langsVal", "繁體中文");
        this.changeLocale = "zh_hk";
      } else if (value == "en") {
        this.$i18n.locale = "en";
        localStorage.setItem("langs", "en");
        localStorage.setItem("langsVal", "English");
        this.changeLocale = "en";
      }
      localStorage.setItem("bgLangsVal", this.changeLocale);
      this.changeLang();
    },
    changeLang() {
      this.$axios({
        method: "get",
        url: this.$build + "/api/changeLocale/" + this.changeLocale
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("ForgetPassword.message")
          });
        });
    }
  }
};
</script>
<style>
.van-field .van-icon {
  font-size: 20px;
}
</style>
<style scoped>
/deep/ .van-dropdown-item__option--active,
/deep/ .van-dropdown-item__option--active,
/deep/ .van-dropdown-item__icon,
/deep/ .van-dropdown-menu__title--active {
  color: #2f75f4;
}
/deep/ .van-dropdown-menu__title {
  color: #fff;
}
/deep/ .van-cell {
  border-bottom: 2px solid #000;
}
/deep/ .van-dropdown-menu__bar {
  background: #000;
  position: relative;
  top: -46px;
}
.login {
  width: 100%;
  min-height: 100vh;
  background: #f3f5f7;
}
.logo {
  text-align: center;
  position: relative;
  height: auto;
}
.bg {
  width: 100%;
}
.log {
  position: absolute;
  /* top: calc(100vw / 750 * 120); */
  top: 45%;
  left: 30%;
}
.inputBox {
  width: 90%;
  border-radius: 10px;
  box-shadow: 5px 5px 5px #666;
  height: 200px;
  position: relative;
  top: -50px;
  left: 5%;
  background: #fff;
}
.box {
  width: 90%;
  margin-left: 5%;
  padding-top: 30px;
}
.loginBtn {
  width: 90%;
  height: 46px;
  background: #000;
  color: #fff;
  position: absolute;
  left: 5%;
  bottom: -23px;
  border-color: #000;
  border-radius: 5px;
}
.intro {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.introItem {
  width: 28%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.introItem > p {
  padding: 0;
  margin: 0;
  font-size: 12px;
}
.next {
  margin-bottom: 20px;
}
.proImg {
  padding-bottom: 5px;
  border-bottom: 2px solid #000;
}
.title {
  width: 100%;
  min-height: 20px;
  line-height: 20px;
  padding: 5px 0;
  text-align: center;
}
.last {
  width: 94%;
  margin: auto;
  padding: 20px 0 60px 0;
}
.last > p {
  padding: 0;
  margin: 0;
  font-size: 14px;
}
.last > .title {
  padding: 10px 0;
  font-size: 20px;
  text-align: left;
}
.copyright {
  color: gray;
  text-align: center;
  margin-top: 30px;
}
.callme {
  background: #2f75f4;
  color: #fff;
  width: 50%;
  margin-left: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue